module.exports = __webpack_public_path__ + "img/Super700.19e7fb2c.png";